
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/ai/ui/freeTextInput/freeTextInput.scss.css.virtualfile';
        module.exports = {"input":"_input_1uoze_7"};